import { render, staticRenderFns } from "./index-rule.vue?vue&type=template&id=3902ad21&scoped=true"
import script from "./index-rule.vue?vue&type=script&lang=js"
export * from "./index-rule.vue?vue&type=script&lang=js"
import style0 from "./index-rule.vue?vue&type=style&index=0&id=3902ad21&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3902ad21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3902ad21')) {
      api.createRecord('3902ad21', component.options)
    } else {
      api.reload('3902ad21', component.options)
    }
    module.hot.accept("./index-rule.vue?vue&type=template&id=3902ad21&scoped=true", function () {
      api.rerender('3902ad21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/rater-assignment/index-rule.vue"
export default component.exports